// LEDaura Lightbox für Multicolumn Bilder
(function () {
  function initLightbox() {
    // Lightbox HTML einfügen falls noch nicht vorhanden
    if (!document.getElementById('ledaura-lightbox')) {
      const lb = document.createElement('div');
      lb.id = 'ledaura-lightbox';
      lb.className = 'ledaura-lightbox';
      lb.innerHTML = '<button class="ledaura-lightbox__close" aria-label="Schließen">&times;</button><img src="" alt="">';
      document.body.appendChild(lb);

      lb.addEventListener('click', function (e) {
        lb.classList.remove('is-open');
      });
    }

    // Alle Bilder in Multicolumn klickbar machen
    const imgs = document.querySelectorAll(
      '.multicolumn-card__image-wrapper img, .multicolumn-card .media img'
    );
    imgs.forEach(function (img) {
      if (img.dataset.lightboxInit) return;
      img.dataset.lightboxInit = '1';
      img.addEventListener('click', function (e) {
        e.stopPropagation();
        const lb = document.getElementById('ledaura-lightbox');
        lb.querySelector('img').src = img.src.replace(/&width=\d+/, '').replace(/\?width=\d+/, '');
        lb.querySelector('img').alt = img.alt;
        lb.classList.add('is-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLightbox);
  } else {
    initLightbox();
  }
})();
